import React, { useState } from "react";
import CardExperto from "./CardExperto";
import "../styles/NuestrosExpertos.css";
import avatarJose from "../assets/images/expertoJose.jpg";
import avatarOmar from "../assets/images/experto1.png.jpg";
import avatarCarlos from "../assets/images/expertoCarlos.jpg";
import { Accordion } from "react-bootstrap";

const NuestrosExpertos = ({
  volverAContactos,
  volverASobreNosotros,
  traducciones,
}) => {
  const isMobile = window.innerWidth <= 768; // Detecta si es móvil

  const expertos = [
    {
      id: "jose",
      name: "José G. Sanmiguel",
      experience: traducciones.expertos.experienciaJose,
      avatar: avatarJose,
    },
    {
      id: "omar",
      name: "Ómar A. Villarreal",
      experience: traducciones.expertos.experienciaOmar,
      avatar: avatarOmar,
    },
    {
      id: "carlos",
      name: "Carlos J. Aponte",
      experience: traducciones.expertos.experienciaCarlos,
      avatar: avatarCarlos,
    },
  ];

  return (
    <div className="expertos-container container-fluid">
      <div className="row justify-content-center text-center">
        <div className="titulo-expertos col-12">
          {traducciones.expertos
            ? traducciones.expertos.titulo
            : "NUESTROS EXPERTOS"}
        </div>
      </div>
      {isMobile ? (
        // Versión móvil con acordeón
        <div className="row">
          {expertos.map((experto) => (
            <div key={experto.id} className="col-12 mb-4">
              <div className="card text-center">
                <img
                  src={experto.avatar}
                  alt={experto.name}
                  className="card-img-top"
                  style={{
                    maxHeight: "200px",
                    objectFit: "cover",
                    objectPosition: "50% 25%", // Ajusta el recorte de la imagen
                  }}
                />
                <div className="card-body">
                  <h5 className="card-title">{experto.name}</h5>
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        {traducciones.idioma === "en"
                          ? "Experience"
                          : "Experiencia"}
                      </Accordion.Header>
                      <Accordion.Body>{experto.experience}</Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        // Versión de escritorio
        <div className="row justify-content-center align-items-stretch">
          {expertos.map((experto) => (
            <div
              key={experto.id}
              className="col-lg-4 col-md-6 col-sm-12 d-flex justify-content-center"
            >
              <CardExperto
                id={experto.id}
                name={experto.name}
                experience={
                  <VerMasMenos
                    text={experto.experience}
                    maxLength={187}
                    traducciones={traducciones}
                  />
                }
                avatar={experto.avatar}
              />
            </div>
          ))}
        </div>
      )}
      <div className="row justify-content-center">
        <div className="col-auto d-flex justify-content-center">
          <button
            className="btn btn-success boton-contacto-expertos"
            onClick={volverAContactos}
          >
            {traducciones.expertos ? traducciones.expertos.boton : "Contacto"}
          </button>
        </div>
      </div>
      <div className="row justify-content-center mt-3">
        <div className="col-auto d-flex justify-content-center">
          <button
            className="btn btn-primary boton-volver-sobre"
            onClick={volverASobreNosotros}
          >
            {traducciones.expertos
              ? traducciones.expertos.volverSobre
              : "Sobre Nosotros"}
          </button>
        </div>
      </div>
    </div>
  );
};

const VerMasMenos = ({ text, maxLength, traducciones }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isMobile = window.innerWidth <= 768; // Detecta si es móvil

  const truncateText = (text) => {
    const firstPeriodIndex = text.indexOf("."); // Encuentra el primer punto
    if (firstPeriodIndex !== -1) {
      return text.substring(0, firstPeriodIndex + 1); // Incluye el punto
    }
    return text; // Si no hay punto, devuelve el texto completo
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  if (isMobile) {
    // En móvil, no se usa este componente
    return null;
  }

  return (
    <div>
      <p>{isExpanded ? text : truncateText(text, maxLength)}</p>
      <button
        className="btn btn-success btn-sm mt-2 btn-ver-mas"
        onClick={toggleExpand}
      >
        {isExpanded
          ? traducciones.expertos.verMenos || "Ver menos"
          : traducciones.expertos.verMas || "Ver más"}
      </button>
    </div>
  );
};

export default NuestrosExpertos;
